import { text2moment, moment2text } from 'core/utils';

export default {
  methods: {
    $text2moment(...args) {
      return text2moment(...args);
    },

    $moment2text(...args) {
      return moment2text(...args);
    },
  }
};
